
const WarningTextPromo = ({ type }) => {
  if (type === 'brand') {
    return (
      <p className="warning-text-promo">
        La marca seleccionada tiene uno o más productos sin empaques disponibles. Elige una marca diferente para continuar.
      </p>
    );
  }

  if (type === 'product') {
    return (
      <p className="warning-text-promo">
        Uno o más productos agregados no tienen una unidad de venta asignada. Verifica el listado antes de continuar.
      </p>
    );
  }

  return null;
};

export default WarningTextPromo;
